
        var result = require("!!../../../../../node_modules/css-loader/index.js!./coal-overview.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/coal/coal-overview/coal-overview.component.css
// module id = 635
// module chunks = 0